module.exports = __webpack_public_path__ + "static/img/9areaA_05.3b45e93.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/9areaA_05.png
// module id = 820
// module chunks = 1